import { z } from 'zod';

const CourseFinderCost = z.array(z.object({
    Id: z.number(),
    Name: z.string(),
}));

export { CourseFinderCost };